/* ==========================================================================
   Premier product page (sections/prem-product.liquid)
   Variant picker, gallery, lightbox, quantity, AJAX add-to-cart (through
   PremTheme.cart from prem-ui.js), sticky add-to-cart bar, and the lazy
   recommendations section (sections/prem-product-recs.liquid).
   ========================================================================== */
(function () {
  'use strict';

  var d = document;
  function qs(sel, el) { return (el || d).querySelector(sel); }
  function qsa(sel, el) { return Array.prototype.slice.call((el || d).querySelectorAll(sel)); }
  function money(cents) {
    return window.PremTheme && window.PremTheme.formatMoney ? window.PremTheme.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
  }

  function initProduct(root) {
    if (root.__premInit) return;
    root.__premInit = true;

    var jsonEl = qs('[data-prem-product-json]', root);
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    var variants = data.variants || [];
    var form = qs('[data-prem-form]', root);
    var idInputs = qsa('form[action*="/cart/add"] input[name="id"]', root);
    var atc = qs('[data-prem-atc]', root);
    var atcLabel = qs('[data-prem-atc-label]', root);
    var atcText = atcLabel ? atcLabel.textContent.trim() : 'Add to cart';
    if (atcText === 'Sold out') atcText = 'Add to cart';
    var errorEl = qs('[data-prem-error]', root);
    var picker = qs('[data-prem-variant-picker]', root);
    var current = null;

    var idNow = idInputs.length ? parseInt(idInputs[0].value, 10) : 0;
    variants.forEach(function (v) { if (v.id === idNow) current = v; });

    /* ---------- Gallery ---------- */
    var track = qs('[data-prem-track]', root);
    var slides = track ? qsa('.prem-gallery__slide', track) : [];
    var thumbs = qsa('[data-prem-thumb]', root);
    var prev = qs('[data-prem-prev]', root);
    var next = qs('[data-prem-next]', root);
    var count = qs('[data-prem-count]', root);
    var index = 0;

    function goTo(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function setIndex(i) {
      index = i;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', parseInt(t.getAttribute('data-prem-thumb'), 10) === i ? 'true' : 'false'); });
      if (count) count.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i >= slides.length - 1;
    }
    if (track && slides.length) {
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== index) setIndex(Math.max(0, Math.min(slides.length - 1, i)));
        });
      }, { passive: true });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-prem-thumb'), 10)); });
      });
      if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, index - 1)); });
      if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, index + 1)); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, index + 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, index - 1)); }
      });
    }
    function showMedia(mediaId, smooth) {
      if (!mediaId) return;
      slides.forEach(function (sl, i) { if (String(sl.getAttribute('data-media-id')) === String(mediaId)) goTo(i, smooth); });
    }

    /* ---------- Lightbox ---------- */
    var lb = qs('[data-prem-lightbox]', root);
    var lbImg = qs('[data-prem-lightbox-img]', root);
    if (lb && lb.showModal) {
      root.addEventListener('click', function (e) {
        var z = e.target.closest('[data-prem-zoom]');
        if (!z) return;
        lbImg.src = z.getAttribute('data-prem-zoom');
        var img = z.parentNode.querySelector('img');
        lbImg.alt = img ? img.alt : '';
        lb.showModal();
      });
      qs('[data-prem-lightbox-close]', lb).addEventListener('click', function () { lb.close(); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === lbImg) lb.close(); });
    } else {
      qsa('[data-prem-zoom]', root).forEach(function (z) { z.hidden = true; });
    }

    /* ---------- Variant picker ---------- */
    function selectedOptions() {
      return qsa('[data-prem-option]', root).map(function (fs) {
        var checked = qs('input:checked', fs) || qs('input[type="hidden"]', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function updateAvailability(opts) {
      qsa('[data-prem-option]', root).forEach(function (fs, oi) {
        qsa('input[type="radio"]', fs).forEach(function (input) {
          var test = opts.slice();
          test[oi] = input.value;
          var v = findVariant(test);
          var unavailable = !v || !v.available;
          var pill = input.closest('.prem-pill');
          if (pill) pill.classList.toggle('is-unavailable', unavailable);
          var note = qs('[data-prem-unavailable]', input.parentNode);
          if (note) note.hidden = !unavailable;
        });
        var legendValue = qs('[data-prem-option-value]', fs);
        if (legendValue && opts[oi] != null) legendValue.textContent = opts[oi];
      });
    }

    function renderPrice(v) {
      var box = qs('[data-prem-price]', root);
      if (!box || !v) return;
      var sale = v.compare_at_price > v.price;
      var html = '<p class="prem-price' + (sale ? ' prem-price--sale' : '') + '"><span class="prem-price__current">' + money(v.price) + '</span>';
      if (sale) html += '<span class="prem-visually-hidden">Regular price</span><s class="prem-price__compare">' + money(v.compare_at_price) + '</s>';
      html += '</p>';
      if (sale) html += '<span class="prem-badge prem-badge--yellow">Save ' + money(v.compare_at_price - v.price).replace('.00', '') + '</span>';
      box.innerHTML = html;
    }

    function renderStock(v) {
      var el = qs('[data-prem-stock]', root);
      if (!el) return;
      el.classList.remove('prem-stock--low', 'prem-stock--out');
      var text = el.getAttribute('data-in-stock-text') || '';
      if (!v || !v.available) { el.classList.add('prem-stock--out'); text = 'Sold out'; }
      else if (v.low_stock > 0) { el.classList.add('prem-stock--low'); text = 'Only ' + v.low_stock + ' left'; }
      el.textContent = text;
      el.hidden = !text;
    }

    function setButtons(v) {
      var available = !!(v && v.available);
      var label = !v ? 'Unavailable' : (available ? atcText : 'Sold out');
      if (atc) atc.disabled = !available;
      if (atcLabel) atcLabel.textContent = label;
      if (sticky) {
        stickyBtn.disabled = !available;
        stickyLabel.textContent = !v ? 'Unavailable' : (available ? 'Add to cart' : 'Sold out');
        if (v) {
          var sp = qs('[data-prem-sticky-price]', sticky);
          if (sp) sp.textContent = money(v.price);
          var sv = qs('[data-prem-sticky-variant]', sticky);
          if (sv) sv.textContent = v.title;
        }
      }
    }

    function onVariantChange(fromUser) {
      var opts = selectedOptions();
      var v = findVariant(opts);
      current = v;
      updateAvailability(opts);
      if (errorEl) errorEl.hidden = true;
      setButtons(v);
      if (!v) return;
      idInputs.forEach(function (input) {
        input.value = v.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      renderPrice(v);
      renderStock(v);
      if (v.media_id) showMedia(v.media_id, fromUser);
      if (fromUser && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (picker) {
      picker.addEventListener('change', function () { onVariantChange(true); });
      updateAvailability(selectedOptions());
    }

    /* ---------- Quantity ---------- */
    var qtyInput = qs('[data-prem-qty-input]', root);
    qsa('[data-prem-qty]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var nextVal = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.getAttribute('data-prem-qty'), 10));
        qtyInput.value = nextVal;
      });
    });

    /* ---------- Add to cart ---------- */
    function showError(msg) {
      if (!errorEl) { if (window.PremTheme && window.PremTheme.toast) window.PremTheme.toast(msg); return; }
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function addToCart(trigger) {
      if (!current || !current.available) return;
      var P = window.PremTheme || {};
      if (!P.cart) { form.submit(); return; }
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      [atc, stickyBtn].forEach(function (b) { if (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); } });
      if (errorEl) errorEl.hidden = true;
      P.cart.add([{ id: current.id, quantity: qty }])
        .then(function () { P.openCart(trigger || atc); })
        .catch(function (err) { showError(err.message); })
        .then(function () {
          [atc, stickyBtn].forEach(function (b) { if (b) { b.classList.remove('is-loading'); b.setAttribute('aria-busy', 'false'); } });
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(atc);
      });
    }

    /* ---------- Sticky add-to-cart ---------- */
    var sticky = qs('[data-prem-sticky]', root);
    var stickyBtn = sticky ? qs('[data-prem-sticky-atc]', sticky) : null;
    var stickyLabel = sticky ? qs('[data-prem-sticky-label]', sticky) : null;
    if (sticky && atc && 'IntersectionObserver' in window) {
      d.body.appendChild(sticky);
      var footer = d.querySelector('footer');
      var atcVisible = true, footerVisible = false;
      var toggle = function () {
        var show = !atcVisible && !footerVisible && atc.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn.tabIndex = show ? 0 : -1;
        d.body.classList.toggle('prem-has-sticky-atc', show);
      };
      new IntersectionObserver(function (entries) { atcVisible = entries[0].isIntersecting; toggle(); }).observe(atc);
      if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; toggle(); }).observe(footer);
      stickyBtn.addEventListener('click', function () {
        if (picker && !current) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        addToCart(stickyBtn);
      });
    }

    if (current) setButtons(current);
  }

  /* ---------- Recommendations ---------- */
  function initRecs(el) {
    if (el.__premInit) return;
    el.__premInit = true;
    var load = function () {
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-prem-recs]');
          if (fresh && fresh.querySelector('[data-prem-card]')) {
            el.innerHTML = fresh.innerHTML;
            el.hidden = false;
          } else {
            el.remove();
          }
        })
        .catch(function () { el.remove(); });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(el);
    } else {
      load();
    }
  }

  function boot() {
    qsa('[data-prem-product]').forEach(initProduct);
    qsa('[data-prem-recs][data-url]').forEach(initRecs);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot);
  else boot();
  d.addEventListener('shopify:section:load', boot);
})();
